import { Color, DefaultValue, getDefaultTransition, getShadow, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

export const SelectContainer = styled.div`
  position: relative;

  input {
    padding-right: ${Spacing.S8};
  }

  &:has(img) {
    input {
      padding-left: ${Spacing.S16};
    }
  }
`

interface SelectMenuContainerProps {
  minWidth?: number
}

export const SelectMenuContainer = styled.div<SelectMenuContainerProps>`
  min-width: ${({ minWidth }) => minWidth || 238}px;
  max-height: 220px;
  padding: ${Spacing.S8};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  ${getShadow('elevatedStrong')};
  overflow: auto;
`

interface SelectMenuItemProps {
  active?: boolean
}

export const SelectMenuItem = styled.div<SelectMenuItemProps>`
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${({ active }) => (active ? Color.Grey100 : Color.White)};
  cursor: pointer;
  ${getDefaultTransition('background-color')};

  ${({ active }) =>
    !active &&
    css`
      &:hover {
        background-color: ${Color.Grey100};
      }
    `}
`

export const InputPrefixImage = styled.img`
  max-width: 20px;
  position: absolute;
  top: 10px;
  left: 6px;
`
